module.exports = __webpack_public_path__ + "static/media/USD.11c4f408.webp";